import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'src/app/providers/navigation.service';
import { YoutubeEmbedVideoComponent } from '../new-v2-component/youtube-embed-video/youtube-embed-video.component';
import { MatDialog } from '@angular/material/dialog';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { Subscription } from 'rxjs';
import { SelectBusinessCountryComponent } from 'src/app/shared/components/select-business-country/select-business-country.component';

@Component({
  selector: 'sm-new-recharges',
  templateUrl: './new-recharges.component.html',
  styleUrls: ['./new-recharges.component.scss']
})
export class NewRechargesComponent implements OnInit {
  selectedValue: string = '2'
  loader:boolean = false
  _apiSubscription: Subscription 
  subsData: any = []
  showBusinesPlaceholder:boolean = false
  transactionData: any = []
  isfromhere:boolean = false
  businessListData: any = []
  constructor(private loaderService: LoaderServiceService,private _apiService: ApiService,private navservice:NavigationService, private router:Router, private dialog:MatDialog,) 
  { this.navservice.hideSidebarAndNav=false

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      console.log("inBookings1:", resData)
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_TRANSACTIONS_LIST){
        this.transactionData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            this.transactionData.push(element)
          });
        }
        this.isfromhere = true
        this._apiService.getBasicEntityList()


      }

      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST){
        if(this.isfromhere){
          this.isfromhere = false
          this.businessListData = []
          if(resData.result){
            this.businessListData = resData.result
            // this.businessListData.forEach((element:any) => {
            //   element.isSelected = 0
             
            // });
  
            this.businessListData = this.businessListData
            .map((element: any) => ({
              ...element, // Spread existing properties
              isSelected: 0 // Add the isSelected property
            }))
            .filter((element: any) => 
              (element.is_owner == 1 )
            );
           
            
            }
          console.log(this.businessListData.length);
          console.log(this.transactionData.length);
          
          if(this.businessListData.length == 0 && this.transactionData.length == 0){
            this.showBusinesPlaceholder = true
          }  
          this.loaderService.showLoader = false
          this.loader = false
          this.hidediv = false

        }
    }

      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_SUBSCRIPTION_HISTORY_BY_ID){
        this.subsData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            this.subsData.push(element)
          });
        }
        this.loaderService.showLoader = false
        this.loader = false
        this.hidediv = false
      }
     
     

     
      
        
    });


  }
  ngOnInit(): void {
    this.subsData = []
    this.transactionData = []
    this.loader = true
    this.showBusinesPlaceholder = false
    this.loaderService.showLoader = true
    this._apiService.getTransactionsList()
  }
displayedColumns: string[] = [
  'packName',
  'description',
  'noOfUsers',
  'noOfEntity',
  'plancost',
  'totalCost',
  'validity',
  'purchasedOn',
  'transactionid'
];
displayedColumns2: string[] = [
  'packName',
  'description',
  'noOfUsers',
  'noOfUsersUsed',
  'noOfEntity',
  'noOfEntitiesUsed',
  'plancost',
  'validity',
  'purchasedOn',
  
];


createbusiness(){
  this.router.navigate(['/purchased-plan'])
}
hidediv:boolean =false
countryInfo:any = typeof sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT) == 'string' ? JSON.parse(sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)!) : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)
  
changeChip(value:string){
  this.selectedValue = value
  this.hidediv = true
  this.loaderService.showLoader = true;
  // this.subsData = []
  // this.transactionData = []
  
  if(value == '0'){
    this._apiService.getSubcriptionHistoryById(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID), '0','all')
  }
  else if(value == '1'){
    this._apiService.getSubcriptionHistoryById(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID), '1','all')
  }
  else if(value == '2'){
    this._apiService.getTransactionsList()
  }
  
}
openhelpsection(){
  this.router.navigate(['/business/help']);

  }
  openLink(url: string): void {
    window.open(url, '_blank');
  }
  opencontact(){
    this.router.navigate(['/contact-us']);
  }


  selectcountry(){
    let dialogref = this.dialog.open(SelectBusinessCountryComponent,{
    width:'500px',
    disableClose:true,
    data:{
      link:"",
      title: 'Select business country',
      ref: this.dialog
    }})
    dialogref.afterClosed().subscribe(res => {
      if(res){
        this.router.navigate(['purchased-plan']);
      }
    } 
    )
    }
}
